var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalisation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#EF7E32;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st0",
    d: "M213.3,262h-47.4c-2.2,0-3.9-1.8-3.9-3.9v-96.3c-2,1-4.2,1.6-6.6,1.6h-1 c-8,0-14.4-6.5-14.4-14.4v-52c0-13.6,11.1-24.7,24.7-24.7h49.9c13.6,0,24.7,11.1,24.7,24.7v52c0,8-6.5,14.4-14.4,14.4h-1 c-2.4,0-4.6-0.6-6.6-1.6v96.3C217.3,260.2,215.5,262,213.3,262z M169.8,254.1h39.5V148.9c0-2.2,1.8-3.9,3.9-3.9 c2.2,0,3.9,1.8,3.9,3.9c0,3.6,2.9,6.6,6.6,6.6h1c3.6,0,6.6-2.9,6.6-6.6v-52c0-9.3-7.5-16.8-16.8-16.8h-49.9 c-9.3,0-16.8,7.5-16.8,16.8v52c0,3.6,2.9,6.6,6.6,6.6h1c3.6,0,6.6-2.9,6.6-6.6c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9V254.1z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M165.9,152.8c-2.2,0-3.9-1.8-3.9-3.9v-35.4c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v35.4 C169.8,151,168.1,152.8,165.9,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M213.3,152.8c-2.2,0-3.9-1.8-3.9-3.9v-35.4c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v35.4 C217.3,151,215.5,152.8,213.3,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M189.6,67.7c-14.2,0-25.7-12.1-25.7-27s11.5-27,25.7-27s25.7,12.1,25.7,27 S203.8,67.7,189.6,67.7z M189.6,21.6c-9.8,0-17.8,8.6-17.8,19.1c0,10.5,8,19.1,17.8,19.1s17.8-8.6,17.8-19.1 C207.4,30.2,199.4,21.6,189.6,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M189.6,262c-2.2,0-3.9-1.8-3.9-3.9v-80.4c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9v80.4 C193.5,260.2,191.8,262,189.6,262z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M91.1,255.8c-19.1,0-34.6-15.5-34.6-34.6s15.5-34.6,34.6-34.6c1.6,0,3.2,0.1,4.7,0.3 c2.2,0.3,3.7,2.3,3.4,4.4c-0.3,2.2-2.3,3.7-4.4,3.4c-1.2-0.2-2.4-0.2-3.7-0.2c-14.7,0-26.7,12-26.7,26.7s12,26.7,26.7,26.7 s26.7-12,26.7-26.7c0-3.6-0.7-7.1-2.1-10.4c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1c1.8,4.3,2.7,8.8,2.7,13.5 C125.7,240.3,110.2,255.8,91.1,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M90.7,236.4c-1.6,0-3-0.9-3.6-2.4l-15.9-37.2c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1 l11.8,27.5c4.3-11.3,13-28.9,28.1-37.7c1.9-1.1,4.3-0.4,5.4,1.4c1.1,1.9,0.4,4.3-1.4,5.4c-19.8,11.5-27.7,42.7-27.7,43 c-0.4,1.6-1.8,2.9-3.5,3C90.9,236.4,90.8,236.4,90.7,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M91.1,175.9c-19.1,0-34.6-15.5-34.6-34.6c0-19.1,15.5-34.6,34.6-34.6c1.6,0,3.2,0.1,4.7,0.3 c2.2,0.3,3.7,2.3,3.4,4.4c-0.3,2.2-2.3,3.7-4.4,3.4c-1.2-0.2-2.4-0.2-3.7-0.2c-14.7,0-26.7,12-26.7,26.7s12,26.7,26.7,26.7 s26.7-12,26.7-26.7c0-3.6-0.7-7.1-2.1-10.4c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1c1.8,4.3,2.7,8.8,2.7,13.5 C125.7,160.4,110.2,175.9,91.1,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M90.7,156.5c-1.6,0-3-0.9-3.6-2.4l-15.9-37.2c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1 l11.8,27.5c4.3-11.3,13-28.9,28.1-37.7c1.9-1.1,4.3-0.5,5.4,1.4c1.1,1.9,0.4,4.3-1.4,5.4c-19.8,11.5-27.7,42.7-27.7,43 c-0.4,1.6-1.8,2.9-3.5,3C90.9,156.5,90.8,156.5,90.7,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M91.1,96C72,96,56.5,80.4,56.5,61.4c0-19.1,15.5-34.6,34.6-34.6c1.6,0,3.2,0.1,4.7,0.3 c2.2,0.3,3.7,2.3,3.4,4.4c-0.3,2.2-2.3,3.7-4.4,3.4c-1.2-0.2-2.4-0.2-3.7-0.2c-14.7,0-26.7,12-26.7,26.7s12,26.7,26.7,26.7 s26.7-12,26.7-26.7c0-3.6-0.7-7.1-2.1-10.4c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1c1.8,4.3,2.7,8.8,2.7,13.5 C125.7,80.4,110.2,96,91.1,96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M90.7,76.6c-1.6,0-3-0.9-3.6-2.4L71.1,37c-0.9-2,0.1-4.3,2.1-5.2c2-0.9,4.3,0.1,5.2,2.1 l11.8,27.5c4.3-11.3,13-28.9,28.1-37.7c1.9-1.1,4.3-0.4,5.4,1.4c1.1,1.9,0.4,4.3-1.4,5.4c-19.8,11.5-27.7,42.7-27.7,43 c-0.4,1.6-1.8,2.9-3.5,3C90.9,76.6,90.8,76.6,90.7,76.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalisation);
export default __webpack_public_path__ + "static/media/normalisation.0f5a58ba995969e551d5100116cdcff8.svg";
export { ForwardRef as ReactComponent };